module.exports = __webpack_public_path__ + "media/images/niq-trash-03dc0b46d1067bcc35821e31064f6598.svg";